import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found — TeaDM" description="This page spilled. Head back to the TeaDM menu or find your nearest store." path="/404" />
      <PageHero testId="not-found" bg="#8b6cf2" eyebrow="404" lines={["This page", "spilled."]} intro="Let's get you back to something delicious.">
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" className="btn btn-cream" data-testid="notfound-home-btn">Home</Link>
          <Link to="/menu" className="btn btn-ink" data-testid="notfound-menu-btn">Menu</Link>
        </div>
      </PageHero>
    </>
  );
}
